import { motion } from "framer-motion";
import { MapPin, Clock, ChatText, HandCoins } from "@phosphor-icons/react";

const FACTS = [
  { Icon: MapPin, k: "Based in", v: "Arizona" },
  { Icon: Clock, k: "Hours", v: "Mon–Fri · 9am–5pm AZ" },
  { Icon: ChatText, k: "Replies", v: "Within one business day" },
  { Icon: HandCoins, k: "Terms", v: "Month-to-month · no contracts" },
];

const PRINCIPLES = [
  ["Built for service businesses", "Contractors, detailers, landscapers, pest control, scrap yards — businesses that win work from a phone call or a quote form, not a shopping cart."],
  ["We've run one ourselves", "WebJesters comes out of running a local service business. We know what a quote request looks like at 7pm from a job site, so we build for that."],
  ["Plain English, no sales calls", "You'll get a written plan, clear pricing, and a draft to approve before anything goes live. Nothing is published without your okay."],
];

export default function About() {
  return (
    <section
      id="about"
      data-tone="light"
      data-testid="about-section"
      className="tone-light relative py-16 sm:py-24 md:py-28 bg-[#f6f5f1] border-y border-zinc-200 scroll-mt-16 md:scroll-mt-20"
    >
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 lg:px-14 grid lg:grid-cols-12 gap-10 lg:gap-14 items-start">
        <div className="lg:col-span-5">
          <div className="text-[11.5px] tracking-[0.22em] uppercase text-brand-700 flex items-center gap-3">
            <span className="block w-8 h-px bg-brand-700" />
            About WebJesters
          </div>
          <h2 className="mt-5 font-display font-bold text-[34px] sm:text-5xl lg:text-[52px] leading-[1.02] tracking-tight text-zinc-900">
            An Arizona web and local-visibility company for the trades.
          </h2>
          <p className="mt-5 text-[15px] text-zinc-600 leading-relaxed">
            We build and run websites, set up Google Business Profiles, and keep local businesses visible — then stay on
            as the team that maintains it. One point of contact, one monthly bill, and no agency retainers.
          </p>
          <dl className="mt-8 grid grid-cols-2 gap-x-6 gap-y-5">
            {FACTS.map((f) => (
              <div key={f.k} data-testid={`about-fact-${f.k.toLowerCase().replace(/\s+/g, "-")}`} className="relative pl-7">
                <f.Icon size={16} weight="regular" className="absolute left-0 top-[3px] text-brand-700" aria-hidden />
                <dt className="text-[11px] tracking-[0.18em] uppercase text-zinc-600">{f.k}</dt>
                <dd className="mt-0.5 text-[14px] text-zinc-900">{f.v}</dd>
              </div>
            ))}
          </dl>
        </div>
        <div className="lg:col-span-7 grid sm:grid-cols-3 gap-4">
          {PRINCIPLES.map(([h, p], i) => (
            <motion.div
              key={h}
              data-testid={`about-principle-${i}`}
              initial={{ opacity: 0, y: 16 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.6, delay: i * 0.08, ease: [0.22, 1, 0.36, 1] }}
              className="card-light rounded-3xl p-6 sm:p-7"
            >
              <div className="font-mono text-[12px] tracking-[0.2em] text-brand-700">0{i + 1}</div>
              <h3 className="mt-4 font-display font-bold text-[19px] leading-snug tracking-tight text-zinc-900">{h}</h3>
              <p className="mt-2.5 text-[14px] text-zinc-600 leading-relaxed">{p}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
